const COL_WIDTHS = ['w-2/5', 'w-1/3', 'w-1/4', 'w-1/5', 'w-1/6', 'w-1/4'];

interface TeeTableSkeletonProps {
  cols?: number;
  rows?: number;
}

export function TeeTableSkeleton({ cols = 5, rows = 8 }: TeeTableSkeletonProps) {
  return (
    <div className="w-full animate-pulse rounded-[10px] border border-[var(--border-default)] overflow-hidden">
      <div className="flex gap-4 px-4 py-3 border-b border-[var(--border-default)] bg-[var(--background-card-elevated)]">
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className={`h-3 rounded ${COL_WIDTHS[i % COL_WIDTHS.length]} bg-[var(--background-card-hover)]`} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div
          key={r}
          className="flex gap-4 px-4 py-3.5 border-b border-[var(--border-default)] last:border-0"
          style={{ background: r % 2 === 0 ? 'var(--background-card)' : 'var(--background-card-elevated)' }}
        >
          {Array.from({ length: cols }).map((_, i) => (
            <div key={i} className={`h-3 rounded ${COL_WIDTHS[i % COL_WIDTHS.length]} bg-[var(--background-card-hover)]`} />
          ))}
        </div>
      ))}
    </div>
  );
}
